import { useEffect, useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { AnnouncementList } from "@/components/AnnouncementList";
import { api } from "@/lib/api";

export default function AnnouncementsPage() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/announcements").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);
  return (
    <div data-testid="announcements-page">
      <Navbar />
      <main className="max-w-3xl mx-auto px-5 sm:px-8 pt-32 pb-24">
        <p className="eyebrow text-purple-500">Announcements</p>
        <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight">News from the network.</h1>
        <div className="mt-12">{items && <AnnouncementList items={items} />}</div>
      </main>
      <Footer />
    </div>
  );
}
